import * as api from "./client.js";

export type CxiReportGrant = {
  id: number;
  userId: string;
  userEmail: string;
  practiceAreaIds: number[];
};

export type CxiGrantUser = {
  id: string;
  email: string;
};

export type CxiGrantPracticeArea = {
  id: number;
  name: string;
  country: string | null;
};

export type CxiGrantOptions = {
  users: CxiGrantUser[];
  practiceAreas: CxiGrantPracticeArea[];
};

type CxiGrantListEnvelope = {
  data: CxiReportGrant[];
};

type CxiGrantOptionsEnvelope = {
  data: CxiGrantOptions;
};

type CxiGrantForUser = {
  practiceAreaIds: number[];
};

type CxiGrantForUserEnvelope = {
  data: CxiGrantForUser | null;
};

type PracticeAreaOptionsEnvelope = {
  data: { practiceAreas: CxiGrantPracticeArea[] };
};

export const cxiReportGrants = {
  getAll: async (orgId: string): Promise<CxiReportGrant[]> => {
    const envelope = await api.get<CxiGrantListEnvelope>(
      `/v1/admin/organisations/${orgId}/cxi-report-grants`,
    );
    return envelope.data;
  },

  getForUser: async (orgId: string, userId: string): Promise<CxiGrantForUser | null> => {
    const envelope = await api.get<CxiGrantForUserEnvelope>(
      `/v1/admin/organisations/${orgId}/cxi-report-grants/${userId}`,
    );
    return envelope.data;
  },

  getOptions: async (orgId: string): Promise<CxiGrantOptions> => {
    const envelope = await api.get<CxiGrantOptionsEnvelope>(
      `/v1/admin/organisations/${orgId}/cxi-report-grants/options`,
    );
    return envelope.data;
  },

  /**
   * Global taxonomy CXI practice-area options — the same list returned by the admin `getOptions`
   * endpoint. Used to populate the user-screen practice-area picker (D6).
   */
  getPracticeAreaOptions: async (orgId: string): Promise<CxiGrantPracticeArea[]> => {
    const envelope = await api.get<PracticeAreaOptionsEnvelope>(
      `/v1/organisations/${orgId}/cxi-practice-area-options`,
    );
    return envelope.data.practiceAreas;
  },

  upsert: async (orgId: string, userId: string, practiceAreaIds: number[]): Promise<void> => {
    await api.put<void>(`/v1/admin/organisations/${orgId}/cxi-report-grants/${userId}`, {
      practice_area_ids: practiceAreaIds,
    });
  },

  delete: async (orgId: string, userId: string): Promise<void> => {
    await api.del(`/v1/admin/organisations/${orgId}/cxi-report-grants/${userId}`);
  },
};
